export default __webpack_public_path__ + "static/media/inventMgmt5Full.7ddfca10.png";